import { GearSix } from "@phosphor-icons/react";
import { type Dispatch, type SetStateAction, useState } from "react";

import { Button } from "common/components/ui/Button";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { Campaign } from "common/types";

import DesktopDropdown from "./DesktopDropdown";
import MobileDrawer from "./MobileDrawer";

import type { MANAGE_CAMPAIGNS_ACTIONS } from "../../../constants";

interface ManageCampaignsProps {
  selectedCampaigns: Campaign[];
  setSelectedCampaigns: Dispatch<SetStateAction<Campaign[]>>;
}

export default function ManageCampaigns({
  selectedCampaigns,
  setSelectedCampaigns,
}: ManageCampaignsProps) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState<keyof typeof MANAGE_CAMPAIGNS_ACTIONS>();

  function onClose() {
    setIsOpen(false);
    setSelectedCampaigns([]);
  }

  const Component = isDesktop ? DesktopDropdown : MobileDrawer;

  return (
    <Component
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      selectedCampaigns={selectedCampaigns}
      action={action}
      setAction={setAction}
      onClose={onClose}
    >
      <Button variant="secondary-purple" leftIcon={<GearSix />}>
        Manage campaigns
      </Button>
    </Component>
  );
}
